import React, { Component, useState, useEffect } from 'react'
import { withAuth } from './AuthContext'
import { Link, withRouter } from 'react-router-dom'
import Cards from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/es/styles-compiled.css'
import Payment from 'payment'
import Cookies from 'universal-cookie'
import { loadStripe } from '@stripe/stripe-js'
import { setPayAsYouChoosePricing, getCurrencySign } from '../utils/utils'
import { decode } from 'html-entities'
import { gaEvents } from '../analytics/events'

const stripeKey = window.location.origin.includes('localhost')
  ? 'pk_test_518KDziCpZYiw17LY2MYtYdH9etP4Z0M0sHGKsoHMy7x7uavW3cN8mfpTEgiZPwGSc0rx32ZDCMv9g1E4JJmBCq1S00ASeexo7s'
  : 'pk_live_518KDziCpZYiw17LYRTUhBuTjHhAESPtj5SDtaZNXYYmco9GYuTcuNvErxtdJgzOnSpDaTmZn9xY7pTIwfQiAhipy004T59e1Mj'
/*
const stripeKey =
    "pk_test_518KDziCpZYiw17LY2MYtYdH9etP4Z0M0sHGKsoHMy7x7uavW3cN8mfpTEgiZPwGSc0rx32ZDCMv9g1E4JJmBCq1S00ASeexo7s";
*/
const stripePromise = loadStripe(stripeKey)
const cookies = new Cookies()

function GiftYourPayByStripe(props) {
  const userStorage = JSON.parse(localStorage.getItem('ud'))
  const [voucherCode, setVoucherCode] = useState('')
  const [name, setName] = useState(
    userStorage.forename + ' ' + userStorage.surname
  )
  const [number, setNumber] = useState('')
  const [expiry, setExpiry] = useState('')
  const [cvc, setCvc] = useState('')
  const [focused, setFocused] = useState('')
  const [errorText, setErrorText] = useState('')
  const [warningText, setWarningText] = useState('')
  const [loading, setLoading] = useState(false)
  const [responseMessage, setResponseMessage] = useState(null)
  const [membership, setMembership] = useState({
    membershipFee: null,
    membershipFeeStatus: null,
    feeSlug: '',
  })
  const [user, _] = useState(userStorage)
  const [currencySign, setCurrencySign] = useState(null)

  useEffect(() => {
    Payment.formatCardNumber(document.querySelector('[name="number"]'))
    Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))
    Payment.formatCardCVC(document.querySelector('[name="cvc"]'))

    const getPricing = async () => {
      const data = await setPayAsYouChoosePricing(
        user.membershipFee,
        user.currencyValue
      )
      setMembership(data)
    }
    const getCurrency = async () => {
      const data = await getCurrencySign(user.currencyValue)
      setCurrencySign(data.sign)
    }
    getPricing()
    getCurrency()
  }, [])

  const handleInputChange = ({ target }) => {
    switch (target.name) {
      case 'number':
        setNumber(target.value.replace(/ /g, ''))
        break
      case 'expiry':
        setExpiry(target.value.replace(/ |\//g, ''))
        break
      case 'name':
        setName(target.value)
        break
      case 'cvc':
        setCvc(target.value)
        break
      case 'voucherCode':
        setVoucherCode(target.value)
        break
    }
  }

  const handleInputFocus = ({ target }) => {
    console.log('handleInputFocus')
    setFocused(target.name)
  }

  const handleSubmit = () => {
    gaEvents.eventGeneric(
      'button_click',
      'stripe-payment-actioned',
      user.id + '(GIFT) - Stripe page - button - action Stripe payment'
    )

    setErrorText('')
    setLoading(true)

    const paymentDetails = {
      name: name,
      card_no: number,
      ccExpiryMonth: expiry.slice(0, 2),
      ccExpiryYear: expiry.slice(2, 4),
      cvcNumber: cvc,
      voucherCode: voucherCode,
      feeSlug: membership.feeSlug,
      type: 'annual_membership_gift',
    }

    console.log(paymentDetails)

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    }

    axios
      .post('/api/payment/stripeIntent', paymentDetails, headers)
      .then((response) => {
        if (!response.data.success) {
          if (response.data.error == 'requires_source_action') {
            setWarningText('We are processing your transaction. Please wait...')
            sCP(stripeKey, response.data.clientSecret, this, function (_, err) {
              if (!err.error) {
                setResponseMessage(
                  'Your payment been processed successfully. Please wait...'
                )
                setLoading(false)

                const updatedMembership = {
                  membershipFee: membership.membershipFee,
                  membershipFeeStatus: 'completed',
                  feeSlug: membership.feeSlug,
                }
                setResponseMessage('Redirecting...')
                setMembership(updatedMembership)
                props.auth.updateUser(membership).then(() => {
                  axios
                    .get('/api/verify-account-status/gygu1')
                    .then(
                      setTimeout(function () {
                        window.open('/gift-your-grown-up/completed', '_self')
                      }, 2000)
                    )
                    .catch((err) => {
                      console.log(err)
                    })
                })
              } else {
                setErrorText(err.error.message)
                setLoading(false)
              }
            })
          } else {
            setErrorText(response.data.error)
            setLoading(false)
          }
        } else {
          setResponseMessage(
            'Your membership fee has been processed successfully. Please wait...'
          )
          setLoading(false)

          const updatedMembership = {
            membershipFee: membership.membershipFee,
            membershipFeeStatus: 'completed',
            feeSlug: membership.feeSlug,
          }
          setResponseMessage('Redirecting...')
          setMembership(updatedMembership)
          props.auth.updateUser(membership).then(() => {
            axios
              .get('/api/verify-account-status/gygu2')
              .then(
                setTimeout(function () {
                  window.open('/gift-your-grown-up/completed', '_self')
                }, 2000)
              )
              .catch((err) => {
                console.log(err)
              })
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <section className="contact-wrapper gift-payment-wrapper">
      <div className="container">
        <button className="backButtonNew" padding="4px 20px">
          <a onClick={() => props.history.go(-1)}>Back</a>
        </button>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="contact_form">
              <div className="col-12  form-group edit-profile">
                <h3 className="gift-payment-title text-center">
                  You are paying{' '}
                  <b>{decode(currencySign) + props.auth.user.membershipFee}</b>{' '}
                  for a lifetime membership gift
                </h3>
                <p className="text-center fs-6">
                  All payments are securely encrypted using end-to-end
                  encryption (E2EE) via the internet’s leading payment
                  processor, Stripe.
                </p>
                <img
                  src="/images/profile/secured-by-stripe.png"
                  alt=""
                  className="img-secured-by-stripe"
                />
              </div>

              <div className="col-12  form-group edit-profile">
                <Cards
                  number={number}
                  name={name}
                  expiry={expiry}
                  cvc={cvc}
                  focused={focused}
                  // callback={this.handleCallback}
                  locale={{ valid: 'expiry' }}
                />
                <form
                  method="POST"
                  action="/"
                  name="myForm"
                  aria-label="Pay fee"
                  onSubmit={(event) => {
                    event.preventDefault()
                    handleSubmit()
                    return false
                  }}
                >
                  <div className="col-12  form-group">
                    <label>Card number</label>
                    <input
                      type="tel"
                      name="number"
                      placeholder="0000 0000 0000 0000"
                      onKeyUp={handleInputChange}
                      onFocus={handleInputFocus}
                      required
                    />
                  </div>
                  <div className="col-12  form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      onKeyUp={handleInputChange}
                      onFocus={handleInputFocus}
                      onChange={handleInputChange}
                      value={name}
                      required
                    />
                  </div>
                  <div className="col-12  form-group">
                    <label>Expiry date</label>
                    <input
                      type="tel"
                      name="expiry"
                      placeholder="MM/YY"
                      onKeyUp={handleInputChange}
                      onFocus={handleInputFocus}
                      required
                    />
                  </div>
                  <div className="col-12  form-group">
                    <label>CVC</label>
                    <input
                      type="tel"
                      name="cvc"
                      placeholder="CVC"
                      onKeyUp={handleInputChange}
                      onFocus={handleInputFocus}
                      required
                    />
                  </div>
                  <div className="col-12  form-group">
                    <label>Voucher Code (optional)</label>
                    <input
                      type="text"
                      name="voucherCode"
                      placeholder="CODE"
                      onKeyUp={handleInputChange}
                      onFocus={handleInputFocus}
                    />
                  </div>
                  <div
                    className="col-12 form-group"
                    style={{
                      display: errorText ? 'block' : 'none',
                    }}
                  >
                    <label style={{ color: 'red' }}>{errorText}</label>
                  </div>
                  <div
                    className="col-12 form-group"
                    style={{
                      display: warningText.length > 0 ? 'block' : 'none',
                    }}
                  >
                    <label style={{ color: 'blue' }}>{warningText}</label>
                  </div>
                  <div className="col-12 form-group">
                    {loading ? (
                      <button
                        padding="12px 14px"
                        type="button"
                        disabled
                        className="gift-payment-submit-button"
                      >
                        <img src="/images/icons/card.svg" /> Paying{' '}
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    ) : (
                      <button
                        padding="12px 14px"
                        type="submit"
                        className="gift-payment-submit-button"
                      >
                        <img src="/images/icons/card.svg" /> Pay{' '}
                        {decode(currencySign) + props.auth.user.membershipFee}{' '}
                      </button>
                    )}
                  </div>
                  {responseMessage && (
                    <div className="submit-btn">
                      <span className="text-muted">{responseMessage}</span>
                    </div>
                  )}
                  <div className="col-12  form-group">
                    <img
                      src="/images/profile/secured-by-stripe-only-mini.png"
                      alt=""
                      className="img-secured-by-stripe-mini"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default withRouter(withAuth(GiftYourPayByStripe))
